import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy.component';
import { PrivacyPolicyRoutes } from './privacy-policy.routing';

@NgModule({
  declarations: [PrivacyPolicyComponent],
  imports: [CommonModule, RouterModule.forChild(PrivacyPolicyRoutes)],
})
export class PrivacyPolicyModule {}
